<template>
  <div class="war-room-onboarding-step">
    <div v-if="isLoading" class="war-room-onboarding-step__loading-overlay">
      <BravadoSpinnerV2 />
    </div>
    <div v-if="isWelcomeVisible" class="war-room-onboarding-step__welcome">
      Welcome back, {{ $auth.user.username }}!
    </div>
    <div class="war-room-onboarding-step__header">
      {{ header }}
    </div>
    <div v-if="hint" class="war-room-onboarding-step__hint">
      {{ hint }}
    </div>
    <div class="war-room-onboarding-step__content">
      <slot />
    </div>
    <div class="war-room-onboarding-step__footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import BravadoSpinnerV2 from '~/components/common/BravadoSpinnerV2/BravadoSpinnerV2.vue';

export default {
  name: 'WarRoomOnboardingStep',
  components: {
    BravadoSpinnerV2,
  },
  props: {
    header: {
      type: String,
      default: '',
      required: true,
    },
    hint: {
      type: String,
      default: '',
    },
    isWelcomeVisible: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/uikit/utils/transition.scss';

.war-room-onboarding-step {
  width: 100%;
  background-color: var(--theme-color-over-card);
  padding: 24px 24px 0;
  position: relative;
  height: 100%;
  overflow: hidden;

  @include mq('sm') {
    border-radius: 8px;
    margin-bottom: 40px;
    padding: 32px 32px 0;
    height: auto;
    max-width: 592px;
  }

  &__loading-overlay {
    @include flex-center;

    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: var(--theme-color-background);
    z-index: 2;
  }

  &__welcome {
    @include subhead;

    text-align: center;
    color: var(--universal-color-gray-50);
    margin-bottom: 12px;
  }

  &__header {
    @include header5;

    color: var(--theme-color-text);
    text-align: center;
    margin-bottom: 18px;

    @include mq('sm') {
      margin-bottom: 12px;
    }
  }

  &__hint {
    @include body;

    text-align: center;
    color: var(--theme-color-sub-text);
    margin-bottom: 24px;
  }

  &__content {
    padding-bottom: 90px;
    margin-top: 24px;

    @include mq('sm') {
      padding-bottom: 32px;
    }
  }

  &__footer {
    background: var(--theme-color-card);
    height: 72px;
    border-top: 1px solid var(--theme-color-over-card);
    padding: 0 24px;
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;

    @include mq('sm') {
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      margin: 0 -32px;
      position: relative;
      bottom: auto;
      left: auto;
      width: auto;
    }
  }
}
</style>
